import { Icon } from '@trlogic/ui-pack';
import React, { Component } from 'react';
import SegmentDateHistogram from './SegmentDateHistogram';
import SegmentClustering from './SegmentClustering';
import SegmentGroupBy from './SegmentGroupBy';
import SegmentFilter from './SegmentFilter';
import DateHistogramAppearance from '../appearances/DateHistogramAppearance';
import ClusteringAppearance from '../appearances/ClusteringAppearance';
import GroupByAppearance from '../appearances/GroupByAppearance';
import FilterAppearance from '../appearances/FilterAppearance';
import CustomLoading from '../../../custom/CustomLoading';
import { SegmentItem, SegmentItemTabs } from '../../../../domain/chart/ChartDomains';
import { ChartType } from '@trlogic/ui-pack';
import LanguageUtil from '../../../../util/LanguageUtil';

class SegmentContainer extends Component<Props> {
  render() {
    const { segmentItem } = this.props;
    if (segmentItem == null) return <CustomLoading />;
    return (
      <div className={'flex flex-col w-full h-full gap-y-4'}>
        <div className={'flex flex-col gap-y-3 rounded'}>
          <span className={'flex flex-col'}>
            <p className={'text-primary font-medium text-[13px]'}>{LanguageUtil.get({ id: 'common.label.data', defaultMessage: 'Data' })}</p>
          </span>
          <div className={'flex flex-col items-start gap-x-3.5 gap-y-1'}>
            <p className={'text-f-black-3 text-[11px] '}>{LanguageUtil.get({ id: 'common.label.functions', defaultMessage: 'Functions' })}</p>
            <div className={'flex items-center gap-x-2'}>
              {this.getSegmentTabItems().map((tab, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {
                      this.onChangeActiveTab(tab.value);
                    }}
                    className={`flex items-center gap-x-1 cursor-pointer text-[12px]  ${segmentItem?.activeTab == tab.value ? 'text-f-purple' : 'text-f-black-3'}`}
                  >
                    <Icon icon={tab.icon} size={14} />
                    <p className={'flex shrink-0'}>{tab.label}</p>
                  </div>
                );
              })}
            </div>
          </div>
          {this.getTabContent(segmentItem.activeTab)}
        </div>
        <div className={'flex flex-col px-5 py-5 rounded  bg-[#F7F8FA]'}>{this.getAppearanceContent(segmentItem.activeTab)}</div>
      </div>
    );
  }

  private getTabContent = (tab: SegmentItemTabs) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    switch (tab) {
      case SegmentItemTabs.DATE_HISTOGRAM:
        return <SegmentDateHistogram segmentItem={segmentItem} onChangeSegmentItem={onChangeSegmentItem} />;
      case SegmentItemTabs.CLUSTERING:
        return <SegmentClustering segmentItem={segmentItem!} onChangeSegmentItem={onChangeSegmentItem} />;
      case SegmentItemTabs.GROUP_BY:
        return <SegmentGroupBy segmentItem={segmentItem} onChangeSegmentItem={onChangeSegmentItem} />;
      case SegmentItemTabs.FILTER:
        return <SegmentFilter segmentItem={segmentItem} onChangeSegmentItem={onChangeSegmentItem} />;
      default:
        return <div>UnsupportedSegment</div>;
    }
  };

  private getAppearanceContent = (tab: SegmentItemTabs) => {
    const { segmentItem, chartType, onChangeSegmentItem, isBreakdown = false } = this.props;
    switch (tab) {
      case SegmentItemTabs.DATE_HISTOGRAM:
        return <DateHistogramAppearance isBreakdown={isBreakdown} onChangeSegmentItem={onChangeSegmentItem} segmentItem={segmentItem} chartType={chartType} />;
      case SegmentItemTabs.CLUSTERING:
        return <ClusteringAppearance isBreakdown={isBreakdown} onChangeSegmentItem={onChangeSegmentItem} segmentItem={segmentItem as SegmentItem} />;
      case SegmentItemTabs.GROUP_BY:
        return <GroupByAppearance isBreakdown={isBreakdown} onChangeSegmentItem={onChangeSegmentItem} segmentItem={segmentItem} />;
      case SegmentItemTabs.FILTER:
        return <FilterAppearance isBreakdown={isBreakdown} onChangeSegmentItem={onChangeSegmentItem} segmentItem={segmentItem} />;
      default:
        return <div>{LanguageUtil.get({ id: 'common.label.unsupportedSegment', defaultMessage: 'Unsupported Segment' })}</div>;
    }
  };

  private onChangeActiveTab = (tab: SegmentItemTabs) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    if (segmentItem == null) return;
    onChangeSegmentItem({ ...segmentItem, activeTab: tab });
  };

  private getSegmentTabItems(): { label: string; value: SegmentItemTabs; icon: string }[] {
    return [
      {
        label: LanguageUtil.get({ id: 'common.label.dateHistogram', defaultMessage: 'Date Histogram' }),
        value: SegmentItemTabs.DATE_HISTOGRAM,
        icon: 'calender',
      },
      { label: LanguageUtil.get({ id: 'common.label.clustering', defaultMessage: 'Clustering' }), value: SegmentItemTabs.CLUSTERING, icon: 'card' },
      { label: LanguageUtil.get({ id: 'common.label.groupBy', defaultMessage: 'Group By' }), value: SegmentItemTabs.GROUP_BY, icon: 'card' },
      //{label: "Filter", value: SegmentItemTabs.FILTER, icon: "filter"}
    ];
  }
}

interface Props {
  segmentItem: SegmentItem | null;
  onChangeSegmentItem: (segmentItem: SegmentItem) => void;
  chartType: ChartType;
  isBreakdown?: boolean;
}

export default SegmentContainer;
